import { IGatsbyImageData } from "gatsby-plugin-image"
import React, { FC } from "react"
import BlogCard from "../BlogCard"

interface Props {
  cards: {
    title: string
    type: string
    image: IGatsbyImageData
    link: string
  }[]
}
const PostsGrid: FC<Props> = ({ cards }) => {
  return (
    <div className="w-full max-w-full mt-12 flex justify-center items-center gap-6 flex-wrap">
      {cards.map((card: any, idx: number) => (
        <BlogCard
          key={idx}
          image={card.image}
          type={card.type}
          title={card.title}
          href={card.link}
        />
      ))}
    </div>
  )
}

export default PostsGrid
